import React from 'react'
import { makeStyles } from '@material-ui/styles';
//import Button from '@material-ui/core/Button';
import { Badge, Fab, Paper, IconButton, Button } from '@material-ui/core';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';


const useStyles = makeStyles((theme) => ({

    containerCompoenet:{ 
        position: "fixed",
        bottom: 0,
        width: "100%",
        padding:  theme.spacing(1.5),
       [theme.breakpoints.up('md')]: {
         //bottom: "10vh",
         left: "30%",
         width: "40%",
         padding:  theme.spacing(3),
       },
       //backgroundColor:"blue",
     },



   buttons: {
    display: 'flex',
    flexDirection:'row',
    justifyContent: 'center',
    width: "100%",
    //margin: theme.spacing(1), 
   },

   buttonNext: {
    minwidth: "40%",
    //marginLeft:"10%"
   },
   buttonBack: { 
    minwidth: "40%"
   },
   fatText: {
    marginRight:  theme.spacing(2),
    marginLeft:  theme.spacing(1),
  },

  fatButget: {
    marginRight:  theme.spacing(2),
    marginLeft:  theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  fatIcon: {
    marginRight:  theme.spacing(1),
    marginLeft:  theme.spacing(1),
    alignItems: 'center',
  },


  buttonMessage: {
    position: "fixed",
    bottom: 80,
    marginLeft:theme.spacing(2), 
    //backgroundColor: 'red', 
   },

}));


export default function CheckOutButtons(props) {
    const classes = useStyles();
    const {basket, labelNext, labelMessage,  onClickMessage, onClickNext} = props; 
    
    return (

        
        <div>
              
        {/* <HideOnScroll  {...props}> */}
        <Paper className={classes.containerCompoenet} elevation={4}>
            
            <div className={classes.buttons}>
                
                <Button  
                 variant="contained" 
                 color="accent"
                 size='large' 
                 className={classes.buttonNext } 
                 onClick = {onClickNext}               
                 >
                   
                  <Badge badgeContent={basket} color="primary" className = {classes.fatButget}>
                  <ShoppingBasketIcon className = {classes.fatIcon} color='primary'/>
                  </Badge>
                    {labelNext}
                 </Button>   
            </div>
      </Paper>
      {/* </HideOnScroll> */}

      </div>
    )
}
